import { useEffect, useState } from 'react';
import { Modal } from '@/components/common/AppModal';
import { Alert, Button, Form } from 'react-bootstrap';

const CONFIRM_WORD = 'حذف';

export function IndexDeleteConfirmModal({
  show,
  urlCount,
  busy,
  onConfirm,
  onClose,
}: {
  show: boolean;
  urlCount: number;
  busy: boolean;
  onConfirm: () => void;
  onClose: () => void;
}) {
  const [confirmText, setConfirmText] = useState('');
  const canConfirm = confirmText.trim() === CONFIRM_WORD;

  useEffect(() => {
    if (!show) setConfirmText('');
  }, [show]);

  return (
    <Modal show={show} onHide={onClose} centered>
      <Modal.Header closeButton>
        <Modal.Title className="fs--1 fw-semibold mb-0">تأیید حذف از نتایج</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Alert variant="danger" className="mb-3">
          آیا واقعاً قصد دارید {urlCount} آدرس را از نتایج گوگل حذف کنید؟ این
          عملیات غیرقابل برگشت است.
        </Alert>
        <p className="text-secondary small mb-2">
          برای ادامه، کلمهٔ <strong>{CONFIRM_WORD}</strong> را دقیقاً در کادر
          زیر بنویسید.
        </p>
        <Form.Control
          value={confirmText}
          autoFocus
          placeholder={CONFIRM_WORD}
          onChange={(e) => setConfirmText(e.target.value)}
          onKeyDown={(e) => {
            if (e.key === 'Enter' && canConfirm && !busy) onConfirm();
          }}
        />
      </Modal.Body>
      <Modal.Footer>
        <Button variant="outline-secondary" disabled={busy} onClick={onClose}>
          انصراف
        </Button>
        <Button
          variant="danger"
          disabled={!canConfirm || busy}
          onClick={onConfirm}
        >
          حذف
        </Button>
      </Modal.Footer>
    </Modal>
  );
}
